import React from 'react';
import { SectionHeader } from '../ui/SectionHeader';
import { CheckList } from '../ui/CheckList';
import { CTAButton } from '../ui/CTAButton';
import { introIncludes } from '../../data/offer';
export function Introduction() {
  return <section className="w-full bg-white px-4 py-16 md:py-24" data-id="element-207" data-mp="17up2xwo64ffv">
      <div className="mx-auto max-w-5xl" data-id="element-208" data-mp="1by3sbdxzy85z">
        <SectionHeader kicker="A new way to study" title="A More Organized Approach to Hair Transplant Education Starts Here" data-id="element-209" data-mp="1bz6jlmz8ecmf" />

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-start" data-id="element-210" data-mp="1lw1elvwapuvy">
          <div className="space-y-4 text-[17px] leading-relaxed text-body md:text-lg" data-id="element-211" data-mp="1ltonot8k8a6r">
            <p data-id="element-212" data-mp="1qoujqkvof58k">
              You have invested time in learning about hair restoration, follicular unit anatomy, patient assessment, hairline
              design, donor area evaluation, and postoperative follow-up.
            </p>
            <p data-id="element-213" data-mp="24m9bvxdbdr48">
              But when you need to revisit a particular concept, organize patient information, or study an unfamiliar clinical
              presentation, finding the right information across multiple resources can be challenging.
            </p>
            <p className="border-l-4 border-cyan pl-4 font-semibold text-heading" data-id="element-214" data-mp="3d9z47eyfcpsu">
              That’s why I created the concept behind HAIR TRANSPLANT BLUEPRINT™: an organized educational collection designed to
              help hair restoration professionals structure their clinical references and professional learning resources.
            </p>
            <p data-id="element-215" data-mp="3vy41c3kktcio">
              Inside, you’ll find six specialized educational volumes, five complementary bonuses, anatomical references,
              assessment frameworks, documentation templates, and educational case studies.
            </p>
            <p data-id="element-216" data-mp="3m6ghanqcmxr8">
              Everything is organized around one central idea: making it easier to study, organize, and revisit educational
              information relevant to hair restoration.
            </p>
          </div>

          <div className="rounded-3xl bg-navy p-6 md:p-8" data-id="element-217" data-mp="2czoe3g6kuni5">
            <h3 className="font-display text-xl font-black uppercase leading-tight text-white" data-id="element-218" data-mp="2d0hl8i9g7f0t">
              Your complete professional reference collection
            </h3>
            <div className="mt-5" data-id="element-219" data-mp="238tpw69rtdu2">
              <CheckList items={introIncludes} tone="dark" data-id="element-220" data-mp="237scvw972h9p" />
            </div>
          </div>
        </div>

        <div className="mt-12" data-id="element-221" data-mp="286mskpbv7ppl">
          <CTAButton label="Get the complete Hair Transplant Blueprint™" sub="Just $27 USD · One-time payment · Digital collection" tone="light" data-id="element-222" data-mp="1tb74r21voq1n" />
        </div>
      </div>
    </section>;
}